// extracted by mini-css-extract-plugin
module.exports = {"card":"Minicard_card__1jntl","img":"Minicard_img__1WE25","content":"Minicard_content__102Il","author":"Minicard_author__x9DO6","title":"Minicard_title__2CSOo"};